<template>
  <div>
    <div class="paypal">
      <form
        action="https://www.paypal.com/cgi-bin/webscr"
        method="post"
        target="_top"
      >
        <input type="hidden" name="cmd" value="_s-xclick" />
        <input type="hidden" name="hosted_button_id" value="93BS3TKUZA438" />
        <input
          type="image"
          src="https://www.paypalobjects.com/en_US/i/btn/btn_donate_SM.gif"
          border="0"
          name="submit"
          title="Because why not?"
          alt="Donate with PayPal button"
        />
        <img
          alt
          border="0"
          src="https://www.paypal.com/en_AT/i/scr/pixel.gif"
          width="1"
          height="1"
        />
      </form>
      <div class="donationInfo pl-2" v-if="showExtraInfos">
        PayPal takes 3.4% + 35c off of every donation.
      </div>
    </div>
    <div class="donationInfo pl-2" v-if="showExtraInfos">
      <!-- <a href="#" @click.prevent="showAlternative = !showAlternative">
        <span v-if="!showAlternative">show alternative</span>
        <span v-else>hide alternative</span>
      </a> -->
    </div>
    <div v-if="showExtraInfos && showAlternative" class="donationInfo pl-2">
      <b-alert show>
        <h4>
          You can send money directly to
          <a href="https://uberspace.de/de/about/imprint/" target="_blank"
            >uberspace</a
          >
          with zero fees.
        </h4>

        <ul>
          <li>Kontoinhaber: Jonas Pasche</li>
          <li>IBAN: DE35550501200200003978</li>
          <li>Verwendungszweck »Uberspace topquiz« *</li>
          <li>BIC: MALADE51MNZ</li>
        </ul>
        <hr />
        <i
          >*Note: Do not alter the purpose text (Verwendungszweck), since
          uberspace uses it to automatically assign incoming money to the
          corresponding accounts.</i
        >
      </b-alert>
    </div>
  </div>
</template>

<script>
export default {
  name: "DonateButton",
  props: {
    formID: {
      default: ""
    },
    showExtraInfos: {
      default: true
    }
  },
  data() {
    return {
      showAlternative: false
    };
  }
};
</script>

<style scoped>
.paypal {
  display: inline-flex;
  align-items: center;
}

.donationInfo {
  font-size: 80%;
  color: #444;
}
</style>
